export default __webpack_public_path__ + "static/media/serviceIcon.44eb1f50.webp";